/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
// eslint-disable-next-line jira/import-whitelist
import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import { JiraProjectAri } from '@atlassian/ari/jira/project';
import log from '@atlassian/jira-common-util-logging/src/log.tsx';
import { performPostRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import type { ProjectDetailsResource } from './ProjectDetailsResource.types.tsx';
import { QUERY } from './BusinessProjectDetailsQuery.tsx';
import type { ProjectDetailsResponse } from './ProjectDetailsResponse.types.tsx';
import { transformData } from './transformData.tsx';

const EMPTY_VALUE: ProjectDetailsResource = {};

export const fetchProjectDetails = async (
	cloudId: string,
	projectKey?: string,
	projectId?: string,
): Promise<ProjectDetailsResource> => {
	const projectIdOrKey = projectId || projectKey;

	if (!projectIdOrKey) {
		return null;
	}

	try {
		const response = await performPostRequest<ProjectDetailsResponse>(
			'/rest/gira/1/?operation=JiraBusinessProjectDetails',
			{
				body: JSON.stringify({
					query: QUERY,
					variables: {
						cloudId,
						projectIdOrKey,
						usingProjectKey: projectId == null,
						projectId:
							projectId != null
								? JiraProjectAri.create({
										siteId: cloudId,
										projectId,
									}).toString()
								: '',
					},
				}),
			},
		);

		return transformData(response.data, projectIdOrKey);
		// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		log.safeErrorWithoutCustomerData(
			'jiraRouterResourcesBusinessProjectDetails',
			'Something went wrong while fetching business project details',
		);

		const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
		if (!isClientError) {
			fireErrorAnalytics({
				meta: {
					id: 'projectDetailsResource',
					packageName: 'jiraRouterResourcesBusinessProjectDetails',
					teamName: 'wanjel',
				},
				error,
				sendToPrivacyUnsafeSplunk: true,
			});

			throw error;
		}
	}

	return EMPTY_VALUE;
};
